import { makeItemPathKey } from '@augloop/session-cache';
import { SchemaObject } from '@augloop/types-core';
/**
 * A partial implementation of WorkflowModelItem needed for ScopeItem.id support. Functionalities not relevant to ScopeItem.id are not implemented.
 * TODO #5326116: This should be just removed once the workflow model from AL server code is adapted to work in browser.
 */
class WorkflowModelItem {
    constructor(item) {
        this.item = item;
        this.operation = item.op;
        this.delta = item.delta;
        this.deltas = item.deltas;
        this.id = makeItemPathKey(this.itemPath);
        this.revId = item.revId;
    }
    get itemPath() {
        return [...this.item.parentPath, this.item.id];
    }
    getModelIterator() {
        throw new Error('Method not implemented.');
    }
    getBody() {
        return this.item.body;
    }
    getItemReference() {
        throw new Error('Method not implemented.');
    }
    getParentItem(_filter) {
        throw new Error('Method not implemented.');
    }
    getParentItemBody(_filter) {
        throw new Error('Method not implemented.');
    }
    getPrevItem(_filter, _parentFilter) {
        throw new Error('Method not implemented.');
    }
    getPrevItemBody(_filter, _parentFilter) {
        throw new Error('Method not implemented.');
    }
    getNextItem(_filter, _parentFilter) {
        throw new Error('Method not implemented.');
    }
    getNextItemBody(_filter, _parentFilter) {
        throw new Error('Method not implemented.');
    }
    getChildItem(_filter) {
        throw new Error('Method not implemented.');
    }
    getChildItemBody(_filter) {
        throw new Error('Method not implemented.');
    }
    getChildItems(_filter) {
        throw new Error('Method not implemented.');
    }
    getChildItemBodies(_filter) {
        throw new Error('Method not implemented.');
    }
    getSubtreeItem(_filter) {
        throw new Error('Method not implemented.');
    }
    getSubtreeItemBody(_filter) {
        throw new Error('Method not implemented.');
    }
    getSubtreeItems(_filter) {
        throw new Error('Method not implemented.');
    }
    getSubtreeItemBodies(_filter) {
        throw new Error('Method not implemented.');
    }
    getContextItem(_filter) {
        throw new Error('Method not implemented.');
    }
    getContextItemBody(_filter) {
        throw new Error('Method not implemented.');
    }
    getContextItems(_filter) {
        throw new Error('Method not implemented.');
    }
    getContextItemBodies(_filter) {
        throw new Error('Method not implemented.');
    }
    addAnnotation(_body, _options) {
        throw new Error('Method not implemented.');
    }
    updateAnnotation(_body, _options) {
        throw new Error('Method not implemented.');
    }
    deleteAnnotation(_options) {
        throw new Error('Method not implemented.');
    }
    loadSubtree(_filter) {
        throw new Error('Method not implemented.');
    }
    getSourceTimestamp() {
        return this.item.sourceTimestamp;
    }
    getContextId() {
        return this.item.contextId;
    }
}
/**
 * HACK, HACK, HACK!
 * A partial implementation of workflow model for needs of personalization context and ScopeItem.id support. Functionalities not relevant to contexts and ScopeItem.id are not implemented.
 * TODO #5326116: This should be just removed once the workflow model from AL server code is adapted to work in browser.
 */
export class WorkflowModel {
    constructor(scopeItem, otherItems = []) {
        this.scopeItem = undefined;
        this.rootItem = undefined;
        this.normalizeFilter = (filter) => {
            if (!filter) {
                return (item) => {
                    return item !== undefined;
                };
            }
            if (typeof filter === 'function') {
                throw new Error('Not implemented yet');
            }
            if ((filter.id ? 1 : 0) + (filter.ids ? 1 : 0) + (filter.itemType ? 1 : 0) + (filter.itemTypes ? 1 : 0) !== 1) {
                throw new Error('Exactly one condition expected on IItemFilter');
            }
            if (filter.itemType) {
                return (item) => {
                    return item && SchemaObject.matchesTypesFor(item.body, [filter.itemType]);
                };
            }
            else if (filter.itemTypes) {
                return (item) => {
                    return item && SchemaObject.matchesTypesFor(item.body, filter.itemTypes);
                };
            }
            else {
                throw new Error('Not implemented yet');
            }
        };
        this.items = [...otherItems, scopeItem];
        this.scopeItem = new WorkflowModelItem(scopeItem);
    }
    getItem(_filter) {
        throw new Error('Method not implemented.');
    }
    getItems(_filter) {
        throw new Error('Method not implemented.');
    }
    getItemBody(filter) {
        const items = this.getItemBodies(filter);
        return items[0];
    }
    getItemBodies(filter) {
        const normalizedFilter = this.normalizeFilter(filter);
        return this.items.filter(normalizedFilter).map(item => item.body);
    }
    getItemByReference(_reference) {
        throw new Error('Method not implemented.');
    }
    getItemBodyByReference(_reference) {
        throw new Error('Method not implemented.');
    }
}
//# sourceMappingURL=workflow-model.js.map